import React, { useState, useEffect } from 'react';
import SecurityMan from '../../assets/images/security-man.svg';
import { Container, TextField } from '@material-ui/core';

import config from '../../services/env';

import { makeStyles } from '@material-ui/core/styles';


const useStyles = makeStyles((theme) => ({
    input: {
        marginBottom: theme.spacing(1.3),
        marginTop: theme.spacing(1.3),
        marginLeft: '0',
        width: '100%',
    },
}));

const copyToClipboard = (text) => {
    const ta = document.createElement("textarea");
    ta.innerText = text;
    document.body.appendChild(ta);
    ta.select();
    document.execCommand("copy");
    ta.remove();
};

const defaultURL = 'https://www.instoreview.cl';

const GetUrlPage = ({ match }) => {
    const classes = useStyles();
    const [isCopied, setIsCopied] = useState(false);
    let clientUrl = defaultURL;

    const handleCopyToClipboard = (value) => {
        copyToClipboard(value);
        setIsCopied(true);
    };

    useEffect(() => {
        if (isCopied) {
            setTimeout(() => setIsCopied(false), 5000);
        }
    }, [isCopied])

    if (match.params.hashCode) {
        clientUrl = `${config.FRONT_URL}clientes/${match.params.hashCode}`;
    }

    return (
        <div className="container-form-2">
            <Container>
                <div className="row d-flex justify-content-center">
                    <img src={SecurityMan} alt="security-man" />
                </div>
                <br />
                <div className="row">
                    <div className="col-12">
                        <h5 className="title-3">¡Bien hecho!</h5>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        <h6 className="title-5">Guardamos tus datos y generamos tu link de acceso.</h6>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        <span className="text">Ingresa al link y completa las claves de tus portales B2B.</span>
                    </div>
                </div>
                <br />
                <div className="row">
                    <div className="col-12">
                        <div className="row">
                            <div className="col-sm-9 col-xs-9">
                                <TextField
                                    id="outlined-basic"
                                    label="Link de acceso"
                                    variant="outlined"
                                    value={clientUrl}
                                    className={classes.input}
                                    margin="dense"
                                    InputProps={{ readOnly: true }}
                                />
                            </div>
                            <div className="col-sm-3 col-xs-3">
                                <button
                                    className="isv-btn btn-primary btn-block btn-url-copy"
                                    onClick={() => handleCopyToClipboard(clientUrl)}
                                >
                                    Copiar
                                </button>
                                {isCopied && <span className="text">¡Link copiado!</span>}
                            </div>
                        </div>
                    </div>
                </div>
            </Container>
        </div>
    );
};

export default GetUrlPage;
